import {ResponseData} from '@dvrd/fetch';
import NavBlock from '../models/navBlockModel';
import {
    ABOUT_ROUTE, DOCUMENTS_ROUTE, LEAVE_ROUTE, NEWSLETTER_ROUTE, REGISTER_ROUTE, TEAM_ROUTE, VACANCIES_ROUTE,
    YEAR_CALENDAR_ROUTE
} from './constants';
import {captureException} from './utils';
import {dispatchCustomEvent, getSetting} from '@dvrd/dvr-controls';

let navBlocks: Array<NavBlock> = [
    new NavBlock(
        {label: 'Onze school', url: ABOUT_ROUTE, image: getSetting('staticURL') + '/cropped-favicon-270x270.png'}),
    new NavBlock({
        label: 'Aanmelden', url: REGISTER_ROUTE,
        image: getSetting('staticURL') + '/cropped-favicon-270x270.png'
    }),
    new NavBlock(
        {label: 'Verlof aanvragen', url: LEAVE_ROUTE, image: getSetting('staticURL') + '/cropped-favicon-270x270.png'}),
    new NavBlock({
        label: 'Nieuwsbrieven', image: getSetting('staticURL') + '/cropped-favicon-270x270.png', url: NEWSLETTER_ROUTE
    }),
    new NavBlock({
        label: 'Jaarkalender', url: YEAR_CALENDAR_ROUTE, image: getSetting('staticURL') + '/cropped-favicon-270x270.png'
    }),
    new NavBlock(
        {label: 'Werken bij', image: getSetting('staticURL') + '/cropped-favicon-270x270.png', url: VACANCIES_ROUTE}),
    new NavBlock({
        label: 'Documenten', url: DOCUMENTS_ROUTE,
        image: getSetting('staticURL') + '/cropped-favicon-270x270.png'
    }),
];

export function getNavBlocks() {
    // TODO
    return navBlocks;
}

function loadNavBlocks() {
    NavBlock.getAll({active: true}, (blocks: Array<NavBlock>, success: boolean, data: ResponseData) => {
        if (!success) return captureException(new Error(data.message));
        navBlocks = blocks;
        navBlocks.sort((blockA: NavBlock, blockB: NavBlock) => blockA.index - blockB.index);
        dispatchCustomEvent('navBlocksLoaded');
    });
}

export const CoreItems: Array<string> = [
    'core-attention',
    'core-enthusiasm',
    'core-selfness',
    'core-trust'
];